// extracted by mini-css-extract-plugin
export default {"hidden":"kGYRhE","link":"gfvdgq","active":"PAntUb","svg":"hocHvX","prev":"AhF1GD","link-active":"qFpy3I","linkActive":"qFpy3I"};